import { gql } from '@apollo/client'

import client from 'api/client'

const MUTATION = gql`
	mutation refuseRoomBooking($id: UUID!, $message: String) {
		refuseRoomBooking(id: $id, message: $message) {
			status
		}
	}
`

const refuseRoomBooking = async (id, message) => {
	const res = await client.mutate({
		mutation: MUTATION,
		variables: { id, message }
	})
	return res.data
}

export default refuseRoomBooking
